import {post, get} from './index'

// 评论插件 - 获取评论星级
export const commentRating = params => get("/osconsumerapi/v1/comment/rating", {params: {...params}})

// 评论插件 - 获取评论列表
export const commentList = body => post("/osconsumerapi/v1/comment/list", {body: {...body}})

export const commentAdd = body => post("/osconsumerapi/v1/comment/add", {body})
